<template>
    <div>
        <div class="m-portlet m-b-10">
            <div class="m-portlet__body">
                <el-table
                        :data="orderWarehouses"
                        style="width: 100%"
                        size="middle"
                        :height="450"
                >
                    <el-table-column label="" width="65">
                        <template scope="scope">
                            <el-radio :label="scope.row.id" v-model="invoiceid" @change.native="handleSelectionChange(scope.$index,scope.row)">&nbsp</el-radio>
                        </template>
                    </el-table-column>
                    <el-table-column prop="name" label="仓库名"></el-table-column>
                    <el-table-column prop="typeName" label="性质"></el-table-column>
                    <el-table-column prop="address" label="地址"></el-table-column>
                </el-table>
            </div>
        </div>
        <div style="text-align: right">
            <el-button size="mini" @click="handleAdd()">确认调货</el-button>
        </div>
    </div>
</template>

<script>
    import store from '@/store'
    export default {
        name: "Dialog_LeaseCargoShop",
        data() {
            return {
                invoiceid:'',
                templateSelection:''
            }
        },
        created() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
            this.handleInfo();
        },
        computed: {
            clientHeight() {
                return this.$store.state.config.clientHeight
            },
            orderWarehouses: function () {
                return this._.orderBy(this.$parentInfo.Dialog_TeacherCargoShop.warehouses, 'id', 'asc');
            }
        },
        methods: {
            handleInfo(){
                this.$axios.get(store.state.server + '/getStore?storeId='+this.$store.state.modal.data.storeId).then((response) => {
                    if (response.data.code == '0000') {
                        this.$parentInfo.Dialog_TeacherCargoShop.warehouses=response.data.content.store
                        this.$parentInfo.Dialog_TeacherCargoShop.loading = false;
                    }
                })
            },
            handleSelectionChange(index,row) {
                this.templateSelection = row;
            },
            handleSizeChange(val) {
                this.$parentInfo.Dialog_TeacherCargoShop.currentPageSize = val;
                this.$parentInfo.Dialog_TeacherCargoShop.loading = true;
                this.handleInfo(this.$parentInfo.Dialog_TeacherCargoShop.currentPage, this.$parentInfo.Dialog_TeacherCargoShop.currentPageSize)
            },
            handleCurrentChange(val) {
                this.$parentInfo.Dialog_TeacherCargoShop.currentPage = val;
                this.$parentInfo.Dialog_TeacherCargoShop.loading = true;
                this.handleInfo(this.$parentInfo.Dialog_TeacherCargoShop.currentPage, this.$parentInfo.Dialog_TeacherCargoShop.currentPageSize)
            },
            handleAdd(){
                this.$axios.post(store.state.server + '/changeStore', {
                        'shopId':this.$store.state.modal.data.shopId,
                        'storeId':this.templateSelection.id
                    }
                ).then((response) => {
                    if (response.data.code == '0000') {
                        this.$delete(this.$parentInfo.teacherDistributions,this.$store.state.modal.data.shopId);
                    }
                })
            },
        }
    }
</script>

<style scoped>

</style>